var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTo = function SvgTo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22b7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e74bb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    xlinkHref: "#lg1",
    y1: 512,
    y2: 0
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 246,
    x2: 246,
    xlinkHref: "#lg1",
    y1: 512,
    y2: 246
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 246,
    x2: 246,
    y1: 335.585,
    y2: 156.415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2013,
    stopColor: "#f3f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6958,
    stopColor: "#dbecee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d2e7ea"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "url(#SVGID_1_)",
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.048 246h-288.096l17.399 226.501c39.542 25.01 86.401 39.499 136.649 39.499 41.652 0 80.977-9.956 115.736-27.605z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.122 232.856-60.675-69.585c-7.259-8.325-19.893-9.189-28.218-1.93s-9.189 19.893-1.93 28.218l31.775 36.441h-204.122c-11.046 0-20 8.954-20 20s8.954 20 20 20h204.122l-31.775 36.441c-7.259 8.325-6.395 20.959 1.93 28.218 3.79 3.305 8.473 4.926 13.136 4.926 5.579 0 11.128-2.321 15.083-6.856l60.675-69.585c6.567-7.532 6.567-18.756-.001-26.288z",
    fill: "url(#SVGID_3_)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/to.88271191.svg";
export { ForwardRef as ReactComponent };